import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { ImgSlider } from './ImgSlider.js';
import data from "../../data/agenda.json";
import styles from './Schecule.module.css'
import './Schecule.css'

export const Schedule = () => {
   const schedule = data;
   const [isSummitTimeZone, setIsSummitTimeZone] = useState(true);
   const [days, setDays] = useState([])
   const location = useLocation()
   const navigate = useNavigate()
   const paths = location.pathname.split('/')
   const day = +paths[paths.length - 1]
   useEffect(() => {
      setDays([{ number: 0, active: day === true }, ...schedule.days_content.map(day_content => ({
         number: day_content.day,
         active: day === day_content.day
      }))]);
   }, [])// eslint-disable-line react-hooks/exhaustive-deps


   const handleNavClick = (dayNum) => {
      const newDay = days.filter(day => day?.number === dayNum)[0]
      if (newDay.active) return
      const otherDays = days.filter(day => day?.number !== dayNum)
      otherDays.forEach(day => day.active = false);
      newDay.active = true
      setDays([...otherDays, newDay])
      navigate(`/agenda/${dayNum}`)
   }

   const handleCheckboxChange = (event) => {
      setIsSummitTimeZone(event.target.checked);
   }

   if (schedule.length === 0) return <></>

   const place = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/')[1]
   const myPlace = place ? place.replaceAll('_', ' ') : 'local'

   return (
      <div key={Math.random()} className={styles.schedule}>
         <div className={styles.container}>
            <header className={styles.header}>
               <nav className={styles.daysNav}>
                  <div
                     onClick={() => handleNavClick(0)}
                     key={Math.random()}
                     className={styles.link}>
                     <button id='glowLink' className={day === 0 ? 'active' : ''}>
                        All days
                        <svg className='svg-animation'>
                           <rect className='rect-blur' pathLength='100'></rect>
                           <rect className='rect-line' pathLength='100'></rect>
                        </svg>
                     </button>
                  </div>
                  {
                     schedule.days_content?.map(day_content =>
                        <div onClick={() => handleNavClick(day_content?.day)} key={Math.random()} className={styles.link}>
                           <button id='glowLink' className={days.filter(day => day?.number === day_content?.day)[0]?.active ? 'active' : ''}>
                              {day_content.name}
                              <svg className='svg-animation'>
                                 <rect className='rect-blur' pathLength='100'></rect>
                                 <rect className='rect-line' pathLength='100'></rect>
                              </svg>
                           </button>
                        </div>
                     )
                  }
               </nav>
               <section className={styles.zone}>
                  <div className={styles.titleZone}>
                     <h6>Time Zone</h6>
                     <span>|</span>
                  </div>

                  <div className={styles.summitZone}>
                     <h6>Summit</h6>
                     <span>Pacific</span>
                  </div>

                  <div id='timeZoneCheckBox'>
                     <label>
                        <input
                           type="checkbox"
                           checked={isSummitTimeZone}
                           onChange={handleCheckboxChange}
                        />
                        <span></span>
                     </label>
                  </div>

                  <div className={styles.localZone}>
                     <h6>Local</h6>
                     <span>{myPlace}</span>
                  </div>
               </section>
            </header>
            {day === 0 ? schedule?.days_content?.map(day_content =>
               <main key={Math.random()} className={styles.main}>
                  <div className={styles.day}>
                     <h6>Day {day_content?.day} - {day_content?.name}</h6>
                  </div>
                  <DaySchedual
                     schedule={schedule}
                     isSummitTimeZone={isSummitTimeZone}
                     day_content={day_content}
                  />
               </main>)
               :
               <main className={styles.main}>
                  <div key={Math.random()} className={styles.day}>
                     <h6>Day {schedule?.days_content[day - 1].day} - {schedule?.days_content[day - 1].name}</h6>
                  </div>
                  <DaySchedual
                     schedule={schedule}
                     isSummitTimeZone={isSummitTimeZone}
                     day_content={schedule?.days_content[day - 1]}
                  />
               </main>}
         </div >
      </div >
   )
}



const DaySchedual = ({ schedule, isSummitTimeZone, day_content }) => {
   return (
      <>
         {
            day_content?.hours.map(hour =>
               <article key={Math.random()} className={styles.hourArtical}>
                  <div className={styles.hour}>
                     <h6>{isSummitTimeZone ? hour?.hour : new Date(`${hour?.datetime} ${schedule?.timezone_diff}`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</h6>
                  </div>
                  <div className={styles.hourArticalMain}>
                     <span></span>
                     {
                        hour.sessions.map(session =>
                           <div key={Math.random()} className={styles.session}>
                              <header className={styles.sessionHeader}>
                                 <div className={styles.sessionHeaderdate}>
                                    {
                                       session.zoom_link &&
                                       <section>
                                          <svg id='roomSvg' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <g clip-path="url(#clip0_3891_4547)">
                                                <path d="M13.1 5.85C13.962 5.85 14.7886 6.19241 15.3981 6.8019C16.0076 7.4114 16.35 8.23805 16.35 9.1C16.35 9.5268 16.2659 9.94941 16.1026 10.3437C15.9393 10.738 15.6999 11.0963 15.3981 11.3981C15.0963 11.6999 14.738 11.9393 14.3437 12.1026C13.9494 12.2659 13.5268 12.35 13.1 12.35C12.238 12.35 11.4114 12.0076 10.8019 11.3981C10.1924 10.7886 9.85 9.96195 9.85 9.1C9.85 8.23805 10.1924 7.4114 10.8019 6.8019C11.4114 6.19241 12.238 5.85 13.1 5.85ZM13.1 0C15.5135 0 17.8281 0.958747 19.5347 2.66533C21.2413 4.37191 22.2 6.68653 22.2 9.1C22.2 15.925 13.1 26 13.1 26C13.1 26 4 15.925 4 9.1C4 6.68653 4.95875 4.37191 6.66533 2.66533C8.37191 0.958747 10.6865 0 13.1 0ZM13.1 2.6C11.3761 2.6 9.72279 3.28482 8.50381 4.50381C7.28482 5.72279 6.6 7.37609 6.6 9.1C6.6 10.4 6.6 13 13.1 21.723C19.6 13 19.6 10.4 19.6 9.1C19.6 7.37609 18.9152 5.72279 17.6962 4.50381C16.4772 3.28482 14.8239 2.6 13.1 2.6Z" fill="black" />
                                             </g>
                                             <defs>
                                                <clipPath id="clip0_3891_4547">
                                                   <rect width="26" height="26" fill="white" />
                                                </clipPath>
                                             </defs>
                                          </svg>
                                          <h6>{session?.zoom_link}</h6>
                                       </section>
                                    }
                                    <section >
                                       <svg id='callenderSvg' width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M19.6516 1.29534L19.5456 1.40011L19.6516 1.29534C19.3699 1.0104 18.9874 0.85 18.5882 0.85H17.2353C16.8361 0.85 16.4537 1.0104 16.172 1.29534C15.8903 1.58023 15.7324 1.96626 15.7324 2.36842V3.58684H9.26765V2.36842C9.26765 1.96626 9.10971 1.58023 8.82805 1.29534C8.54633 1.0104 8.16386 0.85 7.76471 0.85H6.41176C6.01261 0.85 5.63014 1.0104 5.34842 1.29534C5.06676 1.58023 4.90882 1.96626 4.90882 2.36842V3.58954C3.84652 3.62781 2.8359 4.07139 2.08213 4.83379C1.29302 5.63193 0.85 6.71409 0.85 7.84211V22.8947C0.85 24.0228 1.29302 25.1049 2.08213 25.9031C2.87131 26.7013 3.94202 27.15 5.05882 27.15H19.9412C21.058 27.15 22.1287 26.7013 22.9179 25.9031C23.707 25.1049 24.15 24.0228 24.15 22.8947V7.84211C24.15 6.71409 23.707 5.63193 22.9179 4.83379C22.1641 4.07139 21.1535 3.62781 20.0912 3.58954V2.36842C20.0912 1.96626 19.9332 1.58023 19.6516 1.29534ZM13.1765 15.9026H13.0265V16.0526V22.8947V23.0447H13.1765H19.9412H20.0912V22.8947V16.0526V15.9026H19.9412H13.1765ZM18.4382 2.51842V3.58684H17.3853V2.51842H18.4382ZM6.56176 2.51842H7.61471V3.58684H6.56176V2.51842ZM3.25214 6.01233C3.7316 5.52739 4.38152 5.25526 5.05882 5.25526H19.9412C20.6185 5.25526 21.2684 5.52739 21.7479 6.01233C22.2274 6.49733 22.4971 7.15549 22.4971 7.84211V9.06053H2.50294V7.84211C2.50294 7.15548 2.77263 6.49733 3.25214 6.01233ZM3.25214 24.7245C2.77263 24.2395 2.50294 23.5814 2.50294 22.8947V10.7289H22.4971V22.8947C22.4971 23.5814 22.2274 24.2395 21.7479 24.7245C21.2684 25.2095 20.6185 25.4816 19.9412 25.4816H5.05882C4.38152 25.4816 3.7316 25.2095 3.25214 24.7245ZM18.4382 21.3763H14.6794V17.5711H18.4382V21.3763Z" fill="black" stroke="black" strokeWidth="0.3" />
                                       </svg>
                                       <h6>{new Date(session?.datetime_start).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })}</h6>
                                    </section>
                                    <section >
                                       <svg id='watchSvg' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M13.0003 23.2428C15.7168 23.2428 18.322 22.1637 20.2428 20.2429C22.1636 18.3221 23.2427 15.7169 23.2427 13.0004C23.2427 10.284 22.1636 7.67876 20.2428 5.75793C18.322 3.8371 15.7168 2.75799 13.0003 2.75799C10.2838 2.75799 7.67864 3.8371 5.75781 5.75793C3.83698 7.67876 2.75787 10.284 2.75787 13.0004C2.75787 15.7169 3.83698 18.3221 5.75781 20.2429C7.67864 22.1637 10.2838 23.2428 13.0003 23.2428ZM13.0003 0.197388C14.6816 0.197388 16.3465 0.528548 17.8998 1.17196C19.4531 1.81537 20.8645 2.75844 22.0534 3.94731C23.2423 5.13618 24.1853 6.54757 24.8288 8.10091C25.4722 9.65425 25.8033 11.3191 25.8033 13.0004C25.8033 16.396 24.4544 19.6525 22.0534 22.0535C19.6524 24.4546 16.3959 25.8034 13.0003 25.8034C5.92022 25.8034 0.197266 20.0421 0.197266 13.0004C0.197266 9.60484 1.54615 6.34834 3.94719 3.94731C6.34822 1.54627 9.60472 0.197388 13.0003 0.197388ZM13.6404 6.5989V13.3205L19.4018 16.7389L18.4416 18.3137L11.72 14.2807V6.5989H13.6404Z" fill="black" />
                                       </svg>
                                       <h6>{session?.item_duration} Minutes</h6>
                                    </section>
                                 </div>
                                 <h5>{session?.name}</h5>
                                 <h6>{session?.description}</h6>
                              </header>
                              <section className={styles.sessionContent}>
                                 <div id='agendaSpeakersContainer' className={styles.speakersContainer}>
                                    {

console.log(session?.speakers)

                                    }
                                    {
                                       session?.speakers?.length > 0 && <ImgSlider speakers={session?.speakers} />
                                    }
                                 </div>
                              </section>
                           </div>
                        )
                     }
                  </div>
               </article>)
         }
      </>
   )

}